import React, { Component } from 'react';
import { Form, Row, Col, Card, Spinner } from 'react-bootstrap';
import { cloneDeep, isEmpty } from 'lodash';

import { Fetcher } from "../../../Helpers/fetcher.js";

import "./index.css";
import { TEMPLATES } from '../../../Helpers/constant.js';

class VoiceCampaignInfo extends Component {
    constructor(props) {
        super(props);

        let sitePath = '';
        const protocol = window.location.protocol;
        const slashes = protocol.concat("//");
        sitePath = slashes.concat(window.location.hostname);

        this.state = {
            loading: true,
            campaignPrompts: [],
            campaignAgents: [],
            campaignSms: [],
            campaignName: '',
            templateId: '0',
            dtmf: '',
            agentNumber: '',
            agentDtmf: '',
            userId: props.app.userId,
            apiPath: props.app.apiPath,
            sitePath: sitePath,
            filePath: '',
            promptId: '',
            welcomeId: '',
            menuId: '',
            noinputId: '',
            wronginputId: '',
            thanksId: '',
            smsLink: '',
            oldSmsApiSuccess: '',
            oldSmsApiSuccessText: '',
            oldSmsApiSuccessType: '',
            oldSmsApiSuccessPayload: '',
            oldSmsMessageSuccess: '',
            smsApiFail: '',
            oldSmsMessageFail: '',
            oldSmsApiFail: '',
            smsApiDtmf: '',
            oldSmsDtmf: '',
            oldSmsApiDtmf: '',
            smsText: '',
            smsMessage: '',
            connectEvent: '',
            dtmfEvent: '',
            failEvent: '',
            callDurationSMS: 0,
            oldCallDurationSMS: 0,
            trunk: '',
            menuWaitTime: '',
            rePrompt: '',
            connectApiId: '',
            failApiId: '',
            dtmfApiId: '',
            retryInterval: '',
            retries: '',
            ringDuration: '',
            locationList: [],
            cliList: [],
            webhookFlag: false,
            webhookList: [],
            oldWebhookId: '',
            oldWebhookName: '',
            oldWebhookUrl: '',
            sendWebhookUrl: false,
            campRes: '',
            ttsRows: [],
            gender: '',
            language: '',
            selectedLang: '',
            connectPatchEvent: '',
            oldPatchSuccess: '',
            connectPatchApiId: '',
            failPatchEvent: '',
            oldSmsPatchFail: '',
            failPatchApiId: '',
            oldSmsApiFailText: '',
            oldSmsApiFailPayload: '',
            oldSmsApiFailType: '',
            oldSmsApiDtmfText: '',
            oldSmsApiDtmfType: '',
            oldSmsApiDtmfPayload: '',
            oldPatchSuccessText: '',
            oldPatchSuccessType: '',
            oldPatchSuccessPayload: '',
            oldSmsPatchFailText: '',
            oldSmsPatchFailType: '',
            oldSmsPatchFailPayload: '',
            oldSmsApiSuccessHeader: '',
            oldSmsApiFailHeader: '',
            oldSmsApiDtmfHeader: '',
            oldPatchSuccessHeader: '',
            oldSmsPatchFailHeader: '',
            webhookSmsList: [],
            connectSmsDetails: { smsText: '', payload: '', header: '' },
            failSmsDetails: { smsText: '', payload: '', header: '' },
            dtmfSmsDetails: { smsText: '', payload: '', header: '' },
            connectPatchSmsDetails: { smsText: '', payload: '', header: '' },
            failPatchSmsDetails: { smsText: '', payload: '', header: '' },
            ivrList:{},
            repeatMenu:""
        }
    }

    componentDidMount() {
        const campaignId = this.props.campaignId;
        const apiPath = this.state.apiPath;

        // Get Campaign Info
        Fetcher.get(apiPath + '/api/obd/campaign/info/' + campaignId)
            .then(res => {
                this.setState({
                    campaignName: res.campaign.campaignName,
                    validDtmf: res.campaign.dtmf,
                    templateId: res.campaign.templateId,
                    menuWaitTime: res.campaign.menuWaitTime,
                    campaignPrompts: res.campaignPrompts,
                    campaignAgents: res.campaignAgents,
                    campaignSms: res.campaignSms,
                    retryInterval: res.campaign.retryInterval,
                    retries: res.campaign.retries,
                    ringDuration: res.campaign.ringDuration,
                    locationList: res.locationList,
                    cliList: res.cliList,
                    campRes: res,
                    gender: res.campaign.gender,
                    language: res.campaign.language,
                    ttsRows: res.ttsRows,
                    loading: false,
                    ivrList: res?.ivrList?.[0] ?? {},
                    repeatMenu:res.campaign.repeatMenu
                });

                // Set selected language based on language code
                if (this.state.templateId == 7 || this.state.templateId == 8 || this.state.templateId == 9) {
                    if (this.state.language == 'en-IN') {
                        this.setState({ selectedLang: "English" });
                    } else if (this.state.language == 'hi-IN') {
                        this.setState({ selectedLang: "Hindi" });
                    }
                }

                // Process SMS data
                this.processCampaignSmsData();
				this.getWebhooklist(res.campaign.userId);
            })
            .catch(err => {
                console.log('Error in fetching BaseUpload Files', err)
                this.setState({ loading: false });
            });

        Fetcher.get(apiPath + '/api/obd/webhooks/' + this.props.app.userId)
            .then(res => {
                this.setState({ webhookList: res });
            })
            .catch(err => { console.log('Error in fetching webhooks', err) });

      
    }

    getWebhooklist = (uId) => {
        const apiPath = this.props.app.apiPath;
        const userId = uId??this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/sms/webhooks/' + userId)
            .then(res => {
                if(res.error) return;
                this.setState({ webhookSmsList: res });
            })
            .catch(err => { console.log('Error in fetching sms webhooks', err) });
    }

    getSmsWebhookDetail = (wId) => {
        const apiPath = this.props.app.apiPath;
        
        return Fetcher.get(apiPath + '/api/obd/getwebhook/' + wId)
            .then(res => {
                if (res.error) return;
                return res;
            })
            .catch(err => { console.log('Error in fetching sms webhooks', err) });
    }

    // Process campaign SMS data and extract details for each event type
    processCampaignSmsData = () => {
        const campaignSms = this.state.campaignSms;
        
        if (!isEmpty(campaignSms) && (!('error' in campaignSms))) {
            const connectSmsDetails = { smsText: '', payload: '', header: '' };
            const failSmsDetails = { smsText: '', payload: '', header: '' };
            const dtmfSmsDetails = { smsText: '', payload: '', header: '' };
            const connectPatchSmsDetails = { smsText: '', payload: '', header: '' };
            const failPatchSmsDetails = { smsText: '', payload: '', header: '' };
            
            campaignSms.forEach(fileObj => {
                if (fileObj.webhookId !== '') {
                    this.setState({
                        oldWebhookId: fileObj.webhookId,
                        oldWebhookUrl: fileObj.smsText,
                        sendWebhookUrl: true,
                        oldpayload: fileObj.payload,
                        oldheader: fileObj.header
                    });
                }

                if (fileObj.smsEvent === 'CALL_CONNECTED') {
                    this.setState({
                        connectEvent: fileObj.smsEvent,
                        oldSmsApiSuccess: fileObj.smsText,
                        connectApiId: fileObj.apiId,
                        oldCallDurationSMS: fileObj.callDurationSMS,
                        callDurationSMS: fileObj.callDurationSMS,
                        oldSmsApiSuccessText: fileObj.smsMessage,
                        oldSmsApiSuccessType: fileObj.requestType,
                        oldSmsApiSuccessPayload: fileObj.payload,
                        oldSmsApiSuccessHeader: fileObj.header || ''
                    });
                    connectSmsDetails.smsText = fileObj.smsText;
                    connectSmsDetails.payload = fileObj.payload;
                    connectSmsDetails.header = fileObj.header;
                } else if (fileObj.smsEvent === 'CALL_FAILED') {
                    this.setState({
                        failEvent: fileObj.smsEvent,
                        oldSmsApiFail: fileObj.smsText,
                        failApiId: fileObj.apiId,
                        oldSmsApiFailText: fileObj.smsMessage,
                        oldSmsApiFailType: fileObj.requestType,
                        oldSmsApiFailPayload: fileObj.payload,
                        oldSmsApiFailHeader: fileObj.header || ''
                    });
                    failSmsDetails.smsText = fileObj.smsText;
                    failSmsDetails.payload = fileObj.payload;
                    failSmsDetails.header = fileObj.header;
                } else if (fileObj.smsEvent === 'VALID_DTMF') {
                    this.setState({
                        dtmfEvent: fileObj.smsEvent,
                        oldSmsApiDtmf: fileObj.smsText,
                        dtmfApiId: fileObj.apiId,
                        oldSmsApiDtmfText: fileObj.smsMessage,
                        oldSmsApiDtmfType: fileObj.requestType,
                        oldSmsApiDtmfPayload: fileObj.payload,
                        oldSmsApiDtmfHeader: fileObj.header || ''
                    });
                    dtmfSmsDetails.smsText = fileObj.smsText;
                    dtmfSmsDetails.payload = fileObj.payload;
                    dtmfSmsDetails.header = fileObj.header;
                } else if (fileObj.smsEvent === 'PATCH_CONNECTED') {
                    this.setState({
                        connectPatchEvent: fileObj.smsEvent,
                        oldPatchSuccess: fileObj.smsText,
                        connectPatchApiId: fileObj.apiId,
                        oldPatchSuccessText: fileObj.smsMessage,
                        oldPatchSuccessType: fileObj.requestType,
                        oldPatchSuccessPayload: fileObj.payload,
                        oldPatchSuccessHeader: fileObj.header || ''
                    });
                    connectPatchSmsDetails.smsText = fileObj.smsText;
                    connectPatchSmsDetails.payload = fileObj.payload;
                    connectPatchSmsDetails.header = fileObj.header;
                } else if (fileObj.smsEvent === 'PATCH_FAILED') {
                    this.setState({
                        failPatchEvent: fileObj.smsEvent,
                        oldSmsPatchFail: fileObj.smsText,
                        failPatchApiId: fileObj.apiId,
                        oldSmsPatchFailText: fileObj.smsMessage,
                        oldSmsPatchFailType: fileObj.requestType,
                        oldSmsPatchFailPayload: fileObj.payload,
                        oldSmsPatchFailHeader: fileObj.header || ''
                    });
                    failPatchSmsDetails.smsText = fileObj.smsText;
                    failPatchSmsDetails.payload = fileObj.payload;
                    failPatchSmsDetails.header = fileObj.header;
                }
            });

            this.setState({
                connectSmsDetails,
                failSmsDetails,
                dtmfSmsDetails,
                connectPatchSmsDetails,
                failPatchSmsDetails
            });

            if (this.state.sendWebhookUrl && !isEmpty(this.state.webhookList)) {
                this.getSmsWebhookDetail(this.state.oldWebhookId)
                    .then(webhook => {
                        if (webhook) {
                            this.setState({ oldWebhookName: webhook.webhookName });
                        }
                    })
                    .catch(err => console.log('Error fetching webhook:', err));
            }
        }
    }

    // Find webhook name by details
    findWebhookNameByDetails = (smsText, payload, header) => {
        if (!this.state.webhookSmsList || this.state.webhookSmsList.length === 0) {
            return '';
        }

        const normalizedSmsText = smsText || '';
        const normalizedPayload = payload || '';
        const normalizedHeader = header || '';

        const webhook = this.state.webhookSmsList.find(w => {
            return (w.url || '') === normalizedSmsText &&
                (w.payload || '') === normalizedPayload &&
                (w.header || '') === normalizedHeader;
        });

        return webhook ? webhook.webhookName : '';
    }

    // Render method for TTS information table
    renderTtsInfo = () => {
        const ttsTable = this.state.ttsRows.map((item, index) => {
            return <tr key={index}>
                <td>{item.seq}</td>
                <td>{item.ttsType}</td>
                <td>{item.value}</td>
                <td>{item.variableType}</td>
            </tr>;
        });

        return (
            <Row>
                {(this.state.templateId == 7 || this.state.templateId == 8 || this.state.templateId == 9) &&
                    <Col sm={12}>
                        <Form.Label>TTS Info</Form.Label>
                        <div className="react-bootstrap-table">
                            <table className="table table-striped table-bordered table-sm widgetlist-table">
                                <thead>
                                    <tr>
                                        <th>Sequence</th>
                                        <th>Type</th>
                                        <th>Value</th>
                                        <th>Variable Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ttsTable}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                }
            </Row>
        );
    }

    renderCampaignInfo = () => {
        const template = TEMPLATES[this.state.templateId] ?? ""

        let cliDropdown = '';
        if (!isEmpty(this.state.cliList) && (!('error' in this.state.cliList))) {
            cliDropdown = Array.isArray(this.state.cliList) ? this.state.cliList.map((obj, index) => {
                return <option value={obj.cli} key={obj.cli} >{obj.cli}</option>
            }) : []

        } else {
            cliDropdown = <option value="" >No Cli selected</option>
        }

        let locationDropdownOptions = '';
        if (!isEmpty(this.state.locationList)) {
            locationDropdownOptions = this.state.locationList.map((location, index) => (
                <option value={location.location} key={`location${index}`}>
                    {location.location}
                </option>
            ));
        } else {
            locationDropdownOptions = <option value="">No locations selected</option>;
        }

        return (
            <>
                <Row>
                    <Col sm={6}>
                        <Form.Group className="form-group" controlId="campaign-name">
                            <Form.Label>Campaign Name</Form.Label>
                            <Form.Control readOnly value={this.state.campaignName} type="text" />
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group className="form-group">
                            <Form.Label>Campaign Type</Form.Label>
                            <Form.Control readOnly value={template} type="text" />
                        </Form.Group>
                    </Col>
                    {this.state.templateId !== 7 && this.state.templateId !== 3 &&
                        <Col sm={6}>
                            <Form.Group className="form-group">
                                <Form.Label>Valid DTMF</Form.Label>
                                <Form.Control readOnly value={this.state.validDtmf} type="text" />
                            </Form.Group>
                        </Col>
                    }

                    {this.state.repeatMenu && <Col sm={6}>
                        <Form.Group className="form-group">
                            <Form.Label>Repeat Menu</Form.Label>
                            <Form.Control readOnly value={this.state.repeatMenu} type="text" />
                        </Form.Group>
                    </Col>}
                </Row>

                <Row>
                    {(this.state.templateId == 7 || this.state.templateId == 8 || this.state.templateId == 9) &&
                        <Col sm={6}>
                            <Form.Group className="form-group" controlId="gender">
                                <Form.Label>Gender</Form.Label>
                                <Form.Control readOnly value={this.state.gender} type="text" />
                            </Form.Group>
                        </Col>
                    }

                    {(this.state.templateId == 7 || this.state.templateId == 8 || this.state.templateId == 9) &&
                        <Col sm={6}>
                            <Form.Group className="form-group" controlId="language">
                                <Form.Label>Language</Form.Label>
                                <Form.Control readOnly value={this.state.selectedLang} type="text" />
                            </Form.Group>
                        </Col>
                    }
                </Row>

                <Row>
                    {this.state.templateId != 7 && this.state.templateId !== 3 &&
                        (<Col sm={6}>
                            <Form.Group className="form-group">
                                <Form.Label>Menu Wait Time</Form.Label>
                                <Form.Control readOnly value={this.state.menuWaitTime} type="text" />
                            </Form.Group>
                        </Col>)
                    }
                </Row>

                {this.state.templateId === 3 && (
                    <Row>
                        <Col sm={6}>
                            <Form.Group className="form-group">
                                <Form.Label>Custom Ivr Name</Form.Label>
                                <a
                                    href={`${this.props.app.urlPrefix}/ivr/${this.state.ivrList?.ivrId}`}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                        padding: "0.375rem 0.75rem",
                                        fontSize: "1rem",
                                        fontWeight: 400,
                                        lineHeight: 1.5,
                                        color: "#0d6efd",
                                        textDecoration: "underline",
                                        backgroundColor: "#e4e7ea",
                                        border: "1px solid #e4e7ea",
                                        borderRadius: ".25rem",
                                        transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
                                    }}
                                >
                                    {this.state.ivrList?.ivrName}
                                </a>
                            </Form.Group>
                        </Col>

                        <Col sm={6}>
                            <Form.Group className="form-group" controlId="campaign-name">
                                <Form.Label>Custom Ivr Id</Form.Label>
                                <Form.Control readOnly value={this.state.ivrList?.ivrId} type="text" />
                            </Form.Group>
                        </Col>
                    </Row>
                )}


                {this.state.templateId !== 3 && (<Row>
                    <Col sm={6}>
                        <Form.Group className="form-group" controlId="campaign-name">
                            <Form.Label>No. of Retries</Form.Label>
                            <Form.Control readOnly value={this.state.retries} type="text" />
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group className="form-group">
                            <Form.Label>Retry Interval(In Mins)</Form.Label>
                            <Form.Control readOnly value={this.state.retryInterval / 60} type="text" />
                        </Form.Group>
                    </Col>
                </Row>)}

                {this.state.ringDuration > 0 && <Row>
                    <Col sm={6}>
                        <Form.Group className="form-group">
                            <Form.Label>Ring Duration</Form.Label>
                            <Form.Control readOnly value={this.state.ringDuration} type="text" />
                        </Form.Group>
                    </Col>
                </Row>}

                <Row>
                    <Col sm={6}>
                        <Form.Group className="form-group" controlId="campaign-name">
                            <Form.Label>Location</Form.Label>
                            <Form.Select disabled className="dd" name="locations" multiple as="select" htmlSize="5">
                                {locationDropdownOptions}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group className="form-group channels control-label">
                            <Form.Label>Cli</Form.Label>
                            <Form.Select disabled className="dd" name="allocateApiCliId" multiple as="select" htmlSize="5">
                                {cliDropdown}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

               {this.state.templateId !== 3 && (<Row>
                    {this.state.sendWebhookUrl && <Col sm={6}>
                        <Form.Group className="form-group">
                            <Form.Label>Webhook Name</Form.Label>
                            <Form.Control readOnly value={this.state.oldWebhookName} type="text" />
                        </Form.Group>
                    </Col>}

                    {this.state.sendWebhookUrl && <Col sm={6}>
                        <Form.Group className="form-group">
                            <Form.Label>Url</Form.Label>
                            <Form.Control readOnly value={this.state.oldWebhookUrl} type="text" />
                        </Form.Group>
                    </Col>}
                </Row>)}
            </>
        );
    }

    renderLoader = () => {
        return (
            <Row className="justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                <Col sm="auto" className="text-center">
                    <Spinner animation="border" variant="primary" />
                </Col>
            </Row>
        );
    };


    render() {
        if (this.state.loading) {
            return (
                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Header>Voice Campaign Info</Card.Header>
                            <Card.Body>
                                {this.renderLoader()}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            );
        }
        const campaignPrompts = cloneDeep(this.state.campaignPrompts);
        const campaignAgents = cloneDeep(this.state.campaignAgents);

        // Get webhook names for each SMS event
        const connectWebhookName = this.findWebhookNameByDetails(
            this.state.connectSmsDetails.smsText,
            this.state.connectSmsDetails.payload,
            this.state.connectSmsDetails.header
        );
        const failWebhookName = this.findWebhookNameByDetails(
            this.state.failSmsDetails.smsText,
            this.state.failSmsDetails.payload,
            this.state.failSmsDetails.header
        );
        const dtmfWebhookName = this.findWebhookNameByDetails(
            this.state.dtmfSmsDetails.smsText,
            this.state.dtmfSmsDetails.payload,
            this.state.dtmfSmsDetails.header
        );
        const connectPatchWebhookName = this.findWebhookNameByDetails(
            this.state.connectPatchSmsDetails.smsText,
            this.state.connectPatchSmsDetails.payload,
            this.state.connectPatchSmsDetails.header
        );
        const failPatchWebhookName = this.findWebhookNameByDetails(
            this.state.failPatchSmsDetails.smsText,
            this.state.failPatchSmsDetails.payload,
            this.state.failPatchSmsDetails.header
        );

        // Render prompts info
        let promptsInfo = '';
        if (!isEmpty(campaignPrompts) && (!('error' in campaignPrompts))) {
            promptsInfo = campaignPrompts.map((fileObj, index) => {
                return <Row key={`prompt-${index}`}><Col sm={6}>
                    <Form.Group className="form-group">
                        <Form.Label>Prompt Info</Form.Label>
                        <Form.Control key={`prname${index}`} readOnly value={'Name: ' + fileObj.promptName} type="text" />
                        <Form.Control key={`prdur${index}`} readOnly value={'Duration: ' + fileObj.promptDuration} type="text" />
                    </Form.Group>
                </Col>
                </Row>
            });
        }

        // Render agents info
        let agentInfo = '';
        if (!isEmpty(campaignAgents) && (!('error' in campaignAgents))) {
            agentInfo = campaignAgents.map((fileObj, index) => {
                return <Row key={`agent-${index}`}><Col sm={12}>
                    <Form.Group className="form-group">
                        <Form.Label>Agent Info</Form.Label>
                        <Form.Control readOnly key={`agentno${index}`} value={'Group Id : ' + fileObj.groupId} type="text" />
                        <Form.Control readOnly key={`agentdtmf${index}`} value={'Agent DTMF: ' + fileObj.agentDtmf} type="text" />
                    </Form.Group>
                </Col>
                </Row>
            });
        }

        // Render SMS event cards in read-only mode
        const renderSmsEventCard = (event='', webhookName, smsText, smsMessage, smsHeader, requestType, payload, showCallDuration = false) => {
            if (smsText === '') return null;

            return (
                <Card className="mb-4 shadow-sm">
					<Card.Header>{event?.replace("_"," ")}</Card.Header>
                    <Card.Body>
                        <Row className="mb-3">
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Sms Webhook Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={webhookName}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>
                                        {event} &#123;PHONE&#125;
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={smsText}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>

                            {showCallDuration && (
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Call Duration (sec)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.oldCallDurationSMS}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>
                                        {requestType === "GET" ? "SMS Text" : "SMS Payload"}
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        value={requestType === "GET" ? smsMessage : payload}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Header (JSON)</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={smsHeader}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            );
        };

        return (
            <Row>
                <Col sm={12}>
                    <Card>
                        <Card.Header>Voice Campaign Info</Card.Header>
                        <Card.Body>
                            {/* Basic campaign information */}
                            {this.renderCampaignInfo()}

                            {/* Prompts information */}
                            <Row>{promptsInfo}</Row>

                            {/* SMS event cards in read-only mode */}
                            {renderSmsEventCard(
                                this.state.connectEvent,
                                connectWebhookName,
                                this.state.oldSmsApiSuccess,
                                this.state.oldSmsApiSuccessText,
                                this.state.oldSmsApiSuccessHeader,
                                this.state.oldSmsApiSuccessType,
                                this.state.oldSmsApiSuccessPayload,
                                true
                            )}

                            {renderSmsEventCard(
                                this.state.failEvent,
                                failWebhookName,
                                this.state.oldSmsApiFail,
                                this.state.oldSmsApiFailText,
                                this.state.oldSmsApiFailHeader,
                                this.state.oldSmsApiFailType,
                                this.state.oldSmsApiFailPayload
                            )}

                            {renderSmsEventCard(
                                this.state.connectPatchEvent,
                                connectPatchWebhookName,
                                this.state.oldPatchSuccess,
                                this.state.oldPatchSuccessText,
                                this.state.oldPatchSuccessHeader,
                                this.state.oldPatchSuccessType,
                                this.state.oldPatchSuccessPayload
                            )}

                            {renderSmsEventCard(
                                this.state.failPatchEvent,
                                failPatchWebhookName,
                                this.state.oldSmsPatchFail,
                                this.state.oldSmsPatchFailText,
                                this.state.oldSmsPatchFailHeader,
                                this.state.oldSmsPatchFailType,
                                this.state.oldSmsPatchFailPayload
                            )}

                            {renderSmsEventCard(
                                this.state.dtmfEvent,
                                dtmfWebhookName,
                                this.state.oldSmsApiDtmf,
                                this.state.oldSmsApiDtmfText,
                                this.state.oldSmsApiDtmfHeader,
                                this.state.oldSmsApiDtmfType,
                                this.state.oldSmsApiDtmfPayload
                            )}

                            {/* Agents information */}
                            <Row>{agentInfo}</Row>

                            {/* TTS information table */}
                            {this.renderTtsInfo()}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }
}

export default VoiceCampaignInfo;